export var TITLE = 'Perplexity';
export var TEXT_MULTIPLE = 0.75;
export var SPACE_MULTIPLE = 0.2;
export var COLOR_PRIMARY = '#22B8CD';